"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const IntermediateCheckmark = createSVGIcon(
  <path
    d="M4.57129 8L11.4284 8"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "IntermediateCheckmark",
  {
    viewBox: "0 0 16 16",
    titleAccess: "IntermediateCheckmark",
    strokeWidth: 1.5,
  }
);
